<template>
    <div class="index">
      <!-- 顶部 -->
      <PageHeader/>
      <PageNav/>
      <!-- 主题内容 -->
      <keep-alive :include="includedComponents">
          <router-view></router-view>
      </keep-alive>
      <!-- 尾部 -->
      <PageFooterLink v-if="linkList&&linkList.length>0" :linkList="linkList"/>
      <component :is="$route.name == 'contact'?'PageFooterElse':'PageFooter'"></component>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import PageHeader from "@/components/common/PageHeader.vue"
    import PageNav from "@/components/common/PageNav.vue"
    import PageFooter from "@/components/common/PageFooter.vue"
    import PageFooterElse from "@/components/common/PageFooterElse.vue"
    import PageFooterLink from "@/components/common/PageFooterLink.vue"
    export default {
        name: "index",
        data() {
          return {
              includedComponents: []
          };
        },
        computed:{
            ...mapGetters(['linkList'])
        },
        components: {
            PageHeader,
            PageNav,
            PageFooterLink,
            PageFooter,
            PageFooterElse
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/index.vue